// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Interface_wrapper__2b0gu","content":"Interface_content__1tfsL"};